import {Record} from 'immutable';
import moment from 'moment';

const record = Record({
  id: null,
  link: null,
  jobStatusTopic: null,
  startedAt: null,
  erroredAt: null,
  finishedAt: null,
  status: null,
});

class Publication extends record {
  get startedAt() {
    return moment(super.startedAt);
  }

  get erroredAt() {
    return moment(super.erroredAt);
  }

  get finishedAt() {
    return moment(super.finishedAt);
  }
}

export default Publication;



// WEBPACK FOOTER //
// ./app/javascript/records/Publication.js